jQuery(function($) {
  /* navigation */
  $('.mobile-nav-toggle').on('click',function() {
    $('body').toggleClass('menu-open');
    $('.mobile-nav').addClass('menu-open');
    $('.mobile-nav').removeClass('menu-close');

    if ( $('body').hasClass('menu-open') ) {
      $('html > body').height($(window).height());
    } else {
      $('.mobile-nav').addClass('menu-close');
      $('.mobile-nav .sub-menu').removeClass('show');
    }
  })

  $('.mobile-nav li.menu-item-has-children > a').on('click', function(e) {
    $(this).parent().find('.sub-menu').addClass('show');
  })

  $('.mobile-nav li > a[href*="#"], .main-nav li a[href*="#"]').on('click', function(e) {
    e.preventDefault();
  })

  $('.mobile-nav > li.menu-item-has-children > .sub-menu').each(function() {
    var link = '<li><a href="#" class="back-to-main">Back to Main Menu</a></li>';
    $(this).prepend(link);

    bindBackTo();
  })

  function bindBackTo() {
    $('.back-to-main').on('click', function(e) {
      e.preventDefault();
      $(this).parents('.sub-menu').removeClass('show');
    });
  }

  /* Newsletter */
  $('.newsletter-overlay').on('click', function() {
    close_newsletter();
  })

  $(".newsletter-close").on("click", function (e) {
    e.preventDefault();
    close_newsletter();
  })

  $(".newsletter-btn").on("click", function (e) {
    e.preventDefault();
    open_newsletter();
  })

  if( window.location.hash == '#newsletter' ) {
    open_newsletter();
  }

  function open_newsletter() {
    $(".newsletter-drawer").addClass('open');
    $('body').addClass('overlay-open');
  }

  function close_newsletter() {
    $(".newsletter-drawer").removeClass('open');
    $('body').removeClass('overlay-open');
  }

   // JS modal video
   setTimeout(function() { // FIX THIS SO WE DON'T NEED TIMEOUT
    $(".js-modal-btn").modalVideo();
  }, 250)

  // Hash Scroll
  $('a[href*="#"]').not('.newsletter-btn').not('.external-link').not('.pagination a').not('.mobile-nav a')
  .not('.main-nav a').not('#menu-utility-menu a').not('.not-hash-scroll').on('click', function(e) {
    e.preventDefault();
    var target = $(this.hash);
    var scroll = target.offset().top;
    var currentPos = $(window).scrollTop();
    var direction;

    if ( currentPos < scroll ) {
      direction = 'down';
    } else {
      direction = 'up';
    }
    //console.log(currentPos)
    //console.log(scroll)

    if ( $('.site-header').length > 0 && direction == 'up' )
      scroll = scroll - parseInt($('.site-header').outerHeight());

    if ( $('#wpadminbar').length > 0 )
      scroll = scroll - parseInt($('#wpadminbar').outerHeight());

    if ( $(this).data('offset') && $(this).data('offset') != undefined )
      scroll = scroll - $(this).data('offset');

    $('html, body').animate({
      scrollTop: scroll
    }, 800);
  });

  // TOC toggle
  $('.toc-sidebar h6').on('click', function() {
    $('.toc-sidebar').toggleClass('show');
  })

  // TOC Animation
  var scrollTimeout
  var throttle = 50
  var fixed_el = $('.toc-sidebar')
  var admin_bar_el = $('.admin-bar')
  var admin_offset = 32
  //var header_offset = $('.site-header nav').height()
  var offset = 125
  var debug = false

  if ( admin_bar_el.length > 0 )
    offset = offset-admin_offset

  setTimeout(function() {
    if ( fixed_el.length > 0 ) {
      var last_scroll_top = 0
      var top_crossed_el = $('.post-content')
      var top_crossed_el_top = top_crossed_el.offset().top
      var bottom_crossed_el = $('.toc-end')
      var last_kp_block = $('.post-content article .kp-block:last-child')
      var last_kp_block_padding = parseInt(last_kp_block.css('paddingBottom').replace('px', ''))
      var bottom_crossed_el_padding = parseInt(last_kp_block.css('paddingTop').replace('px', ''))
      
      var bottom_crossed_el_position = bottom_crossed_el.offset().top - (bottom_crossed_el_padding) - last_kp_block_padding
      //var bottom_crossed_el_position = bottom_crossed_el.offset().top

      $(window).on('scroll', function() {
        if (!scrollTimeout) {
          scrollTimeout = setTimeout(function () {
            doTocScroll();
            scrollTimeout = null;
          }, throttle);
        }
      });
    }

    function doTocScroll() {
      fixed_el_top = fixed_el.offset().top
      window_top = $(window).scrollTop()
      direction = $(this).scrollTop()

      if ( debug ) {
        console.log('debug on: TOC Sidebar')
        console.log('TOP: ' + (fixed_el_top));
        console.log('BOTTOM: ' + bottom_crossed_el.offset().top)
        console.log('CHECKING PASSED TOP:')
        console.log(window_top + ' - ' + (fixed_el_top-offset))
        console.log('CHECKING PASSED BOTTOM:')
        console.log('PADDING: ' + bottom_crossed_el_padding)
        console.log(((fixed_el_top-offset)+fixed_el.height()) + ' - ' + bottom_crossed_el_position)        
      }

      if (direction < last_scroll_top) {
        // scroll up
        if (fixed_el.hasClass('freeze-toc')) {
          if ( (window_top+offset) < fixed_el_top ) {
            fixed_el.removeClass('freeze-toc')
          }
        }

        // when the toc bar is back at the top
        if (fixed_el.hasClass('scroll-toc')) {
          if (fixed_el_top-offset < top_crossed_el_top ) {
            fixed_el.removeClass('scroll-toc')
          }
        }
      } else {
        // scroll down
        if ( window_top > fixed_el_top-offset ) {
          fixed_el.addClass('scroll-toc')
        }

        // when the fixed el is at the bottom, freeze it
        if ( ((fixed_el_top-offset)+fixed_el.height()) > bottom_crossed_el_position ) {
          fixed_el.addClass('freeze-toc')
        }
      }
    
      last_scroll_top = direction;
    }
  }, 500)
});

// header scroll animation
var scroll_pos = 0;
var last_scroll_pos = 0;
var ticking = false;
var down_scroll_pos_trigger = 130;
var up_scroll_pos_trigger = 75;

var staggered_content = document.querySelectorAll('.block--staggered-fade-in-content');
function staggeredContent() {
  var staggered_content = document.querySelectorAll('.staggered-item');
  var window_bottom = window.scrollY + window.innerHeight;
  var offset = 250;

  var length = staggered_content.length;
  for ( i=0; i<length; i++ ) {
    if ( window_bottom > staggered_content[i].offsetTop+offset ) {
      staggered_content[i].classList.add('reveal');
    }
  }
}

var timeline_content = document.querySelectorAll('.block--timeline');
var timeline_events = document.querySelector('timeline-block');
function timelineAnimation() {
  for (var i = 0; i < timeline_events.length; i++) {
    if (isElementInViewport(timeline_events[i])) {
      timeline_events[i].classList.add("in-view");
    }
  }
}

var fade_in_content = document.querySelectorAll('.kp-fade-in-animation');
function fadeInBlocks() {
  var window_bottom = window.scrollY + window.innerHeight;
  var offset = 250;

  var length = fade_in_content.length;
  for ( i=0; i<length; i++ ) {
    if ( window_bottom > fade_in_content[i].offsetTop+offset ) {
      fade_in_content[i].classList.add('in-view');
    }
  }
}

function animateMenu(scroll_pos, direction) {
  var body_el = document.querySelector('html > body');
  var wrapper_nav = document.querySelector('.site-header');

  if ( scroll_pos > down_scroll_pos_trigger && !wrapper_nav.classList.contains('scrolling-down') && direction === 'down' ) {
    wrapper_nav.classList.add('scrolling-down');
    wrapper_nav.classList.remove('scrolling-up');

    body_el.classList.add('scrolling-down');
    body_el.classList.remove('scrolling-up');
  } else if ( direction === 'up' && !wrapper_nav.classList.contains('scrolling-up') ) {
    wrapper_nav.classList.add('scrolling-up');
    wrapper_nav.classList.remove('scrolling-down');

    body_el.classList.add('scrolling-up');
    body_el.classList.remove('scrolling-down');
  }
  
  if ( scroll_pos < up_scroll_pos_trigger ) {
    wrapper_nav.classList.remove('scrolling-up');
    wrapper_nav.classList.remove('scrolling-down');
    document.querySelector('body').classList.remove('scrolling');
  }

  if ( scroll_pos > down_scroll_pos_trigger ) {
    document.querySelector('body').classList.add('scrolling');
  }
}

window.addEventListener( 'scroll', handleScroll, {passive: true} );

function handleScroll() {
  scroll_pos = window.scrollY;
  if (!ticking) {
    window.requestAnimationFrame(function() {
      direction = getDirection(scroll_pos, last_scroll_pos);
      animateMenu(scroll_pos, direction);

      if ( timeline_content.length > 0 )
        timelineAnimation(scroll_pos);

      if ( staggered_content.length > 0 )
        staggeredContent(scroll_pos);

      if ( fade_in_content.length > 0 )
        fadeInBlocks();

      ticking = false;
      last_scroll_pos = scroll_pos;
    });

    ticking = true;
  }
}

function getDirection(scroll_pos, last_scroll_pos) {
  if ( scroll_pos > last_scroll_pos ) {
    return 'down';
  } else if ( scroll_pos < last_scroll_pos ) {
    return 'up';
  }
}

function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}